import { Project, ProjectAPI } from "@brg/api";

/**
 * Это похоже на какое-то двинутое временное решение? Ну, собственно да, оно таким и является:)
 */
export const BAYER_ID = "d544e46b75774d48b3654bdc2f209998";
export const DDD_ID = "104b268d94d74dd7b71c818e34b6ae1a";

export const NOMINATIONS_STATUSES = [0, 1, 4, 3, 5, 6, 8];

export enum STATUSES {
    'Draft' = 0,
    'Open' = 1,
    'Announcement' = 2,
    'Voting' = 3,
    'Summarizing' = 4,
    'Completed' = 5,
    'Archived' = 6,
    'Deleted' = 7,
    'LonglistFormation' = 8,
}

export enum STATUSES_NEW {
  'Open' = 1,
  'Completed' = 5,
}

export const STATUSES_List: {
    label: string;
    value: number;
  }[] = Object.entries(STATUSES)
    .map(([label, value]) => ({ label: label, value: value as number }))
    .filter(x => !isNaN(x.value));

export enum VOTING_MODE {
  'Classic' = 0,
  'TwoStage' = 1,
}

export const VOTING_MODE_List: {
  label: string;
  value: number;
}[] = Object.entries(VOTING_MODE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

type CompetitionVotingModeSource = {
  isTwoStageAssessment?: boolean;
  votingMode?: number;
  competitionInfo?: { votingMode?: number };
} | null | undefined;

export const getCompetitionVotingMode = (competition?: CompetitionVotingModeSource): number => {
  const raw = competition?.votingMode ?? competition?.competitionInfo?.votingMode;
  return raw === VOTING_MODE.TwoStage ? VOTING_MODE.TwoStage : VOTING_MODE.Classic;
};

export const isTwoStageVotingCompetition = (competition?: CompetitionVotingModeSource): boolean => {
  if (!competition) {
    return false;
  }

  if (competition.isTwoStageAssessment === true) {
    return true;
  }

  if (competition.isTwoStageAssessment === false) {
    return false;
  }

  return getCompetitionVotingMode(competition) === VOTING_MODE.TwoStage;
};

export const COMPETITION_LONGLIST_GET_LIST_PARAM = 'cmptlnglst';

export const COMPETITION_LONGLIST_CHANGED_EVENT = 'competition-longlist-changed';

export const COMPETITION_LONGLIST_VOTE_CRITERIA_ID = '8a8fcc2c48164488ba8451374252e2a6';

export const normalizeJuryVoteValue = (value: unknown): number => {
  if (value === 0 || value === 1) {
    return value;
  }
  if (value === '0' || value === '1') {
    return Number(value);
  }
  return -1;
};

export const getLonglistVoteValueFromCriteriaList = (
  criteriaList: { voteCriteriaId?: string; voteValue?: unknown }[] | undefined,
  voteCriteriaId: string = COMPETITION_LONGLIST_VOTE_CRITERIA_ID,
): number => {
  const current = criteriaList?.find((c) => c?.voteCriteriaId === voteCriteriaId);
  const normalized = normalizeJuryVoteValue(current?.voteValue);
  if (normalized === 0 || normalized === 1) {
    return normalized;
  }
  return -1;
};

export const isLonglistFormationCompetition = (
  competition?: CompetitionVotingModeSource & { status?: number },
): boolean =>
  !!competition
  && isTwoStageVotingCompetition(competition)
  && competition.status === STATUSES.LonglistFormation;

export const isCompetitionLonglistTabVisibleByStatus = (status?: number): boolean => {
  if (status == null) {
    return false;
  }
  if (status === STATUSES.LonglistFormation) {
    return false;
  }
  return status >= STATUSES.Voting;
};

type ProjectCompetitionGpa = {
  competitionId?: string;
  skipByVotes?: boolean;
};

export const isProjectInCompetitionLonglist = (
  project: { competitonsGPA?: ProjectCompetitionGpa[] } | undefined,
  competitionId: string,
): boolean => {
  const row = project?.competitonsGPA?.find((g) => g.competitionId === competitionId);
  return row?.skipByVotes === false;
};

export const shouldRestrictProjectsToCompetitionLonglist = (
  competition?: CompetitionVotingModeSource & { status?: number },
): boolean =>
  !!competition
  && isTwoStageVotingCompetition(competition)
  && competition.status === STATUSES.Voting;

export enum COMPETITION_TYPE {
  'WithoutQuestionnaire' = 0,
  'WithQuestionnaire' = 1,
  'WithNominations' = 3,
  'PreRegistration' = 4,
  'Automatic' = 5,
  'Rating' = 6,
  'RatingArt' = 7,
  'Special' = 8,
  'LmsExam' = 9,
  'RatingsFashion' = 10,
  'RatingsEducation' = 11,
  'RatingsStartups' = 12,
  'RatingsPlus' = 13,
  'Practices' = 14,
  //aki = 2
}

export const RATING_COMPETITION_TYPES: COMPETITION_TYPE[] = [
  COMPETITION_TYPE.Rating,
  COMPETITION_TYPE.RatingArt,
  COMPETITION_TYPE.RatingsFashion,
  COMPETITION_TYPE.RatingsEducation,
  COMPETITION_TYPE.RatingsStartups,
  COMPETITION_TYPE.RatingsPlus,
];

export const isRatingCompetitionType = (type?: number): boolean => {
  if (type === undefined || type === null) {
    return false;
  }

  return RATING_COMPETITION_TYPES.includes(type as COMPETITION_TYPE);
};

export const NEW_DAFES_CHOICE_COMPETITION_TYPES: COMPETITION_TYPE[] = [
  COMPETITION_TYPE.RatingsFashion,
  COMPETITION_TYPE.RatingsEducation,
  COMPETITION_TYPE.RatingsStartups,
  COMPETITION_TYPE.RatingsPlus,
];

export const isNewDafesChoiceCompetitionType = (type?: number): boolean => {
  if (type === undefined || type === null) {
    return false;
  }

  return NEW_DAFES_CHOICE_COMPETITION_TYPES.includes(type as COMPETITION_TYPE);
};

export const normalizedCompetitionStatuses = (): Record<string, number> =>
  Object.entries(STATUSES)
    .filter(([, value]) => typeof value === 'number')
    .reduce<Record<string, number>>((acc, [key, value]) => {
      acc[key.toLowerCase()] = value as number;
      return acc;
    }, {});

export const RATING_PROJECT_TYPE_TO_COMPETITION_TYPE: Record<number, COMPETITION_TYPE> = {
  0: COMPETITION_TYPE.Rating,
  1: COMPETITION_TYPE.RatingArt,
  2: COMPETITION_TYPE.RatingsFashion,
  3: COMPETITION_TYPE.RatingsEducation,
  4: COMPETITION_TYPE.RatingsStartups,
  5: COMPETITION_TYPE.RatingsPlus,
};
export const TEAM_FORM_CONTINUE_COMPETITION_QUERY = 'continueCompetition';
export const TEAM_FORM_DEFER_APPLY_PROJECT_QUERY = 'deferApplyProject';
export const QUERY_LEGAL_CONTEST_PROJECT_THEN_FORM = 'legalContestProjectThenForm';
export const QUERY_RESUME_LEGAL_CONTEST_AFTER_FORM = 'resumeLegalContestAfterForm';

export const PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID = '61557662888148bf807a481e0017c11b';

export const COMPETITION_TYPE_List: {
  label: string;
  value: number;
}[] = Object.entries(COMPETITION_TYPE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

/**
 * Доступ к подаче проекта (актуально для конкурса с пререгистрацией)
 */
export enum COMPETITION_APPLY_PROJECT_TYPE {
  'AllUsers' = 0,
  'ApprovedOnly' = 1,
}

/**
 * Время подачи проекта (актуально для конкурса с пререгистрацией)
 */
export enum COMPETITION_MOMENT_APPLY_PROJECT_TYPE {
  'AfterCompetitionRegistration' = 0,
  'AppointedTime' = 1,
}

export const COMPETITION_APPLY_PROJECT_TYPE_List: {
  label: string;
  value: number;
}[] = Object.entries(COMPETITION_APPLY_PROJECT_TYPE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

export const COMPETITION_MOMENT_APPLY_PROJECT_TYPE_List: {
  label: string;
  value: number;
}[] = Object.entries(COMPETITION_MOMENT_APPLY_PROJECT_TYPE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

export type WinnerT = { project: Project, position: number }

export type NominationWinners = {
  id: string;
  color?: string;
  name: string;
  projects: WinnerT[];
}
import { Project, ProjectAPI } from "@brg/api";

/**
 * Это похоже на какое-то двинутое временное решение? Ну, собственно да, оно таким и является:)
 */
export const BAYER_ID = "d544e46b75774d48b3654bdc2f209998";
export const DDD_ID = "104b268d94d74dd7b71c818e34b6ae1a";

export const NOMINATIONS_STATUSES = [0, 1, 4, 3, 5, 6, 8];

export enum STATUSES {
    'Draft' = 0,
    'Open' = 1,
    'Announcement' = 2,
    'Voting' = 3,
    'Summarizing' = 4,
    'Completed' = 5,
    'Archived' = 6,
    'Deleted' = 7,
    'LonglistFormation' = 8,
}

export enum STATUSES_NEW {
  'Open' = 1,
  'Completed' = 5,
}

export const STATUSES_List: {
    label: string;
    value: number;
  }[] = Object.entries(STATUSES)
    .map(([label, value]) => ({ label: label, value: value as number }))
    .filter(x => !isNaN(x.value));

export enum VOTING_MODE {
  'Classic' = 0,
  'TwoStage' = 1,
}

export const VOTING_MODE_List: {
  label: string;
  value: number;
}[] = Object.entries(VOTING_MODE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

type CompetitionVotingModeSource = {
  isTwoStageAssessment?: boolean;
  votingMode?: number;
  competitionInfo?: { votingMode?: number };
} | null | undefined;

export const getCompetitionVotingMode = (competition?: CompetitionVotingModeSource): number => {
  const raw = competition?.votingMode ?? competition?.competitionInfo?.votingMode;
  return raw === VOTING_MODE.TwoStage ? VOTING_MODE.TwoStage : VOTING_MODE.Classic;
};

export const isTwoStageVotingCompetition = (competition?: CompetitionVotingModeSource): boolean => {
  if (!competition) {
    return false;
  }

  if (competition.isTwoStageAssessment === true) {
    return true;
  }

  if (competition.isTwoStageAssessment === false) {
    return false;
  }

  return getCompetitionVotingMode(competition) === VOTING_MODE.TwoStage;
};

export const COMPETITION_LONGLIST_GET_LIST_PARAM = 'cmptlnglst';

export const COMPETITION_LONGLIST_CHANGED_EVENT = 'competition-longlist-changed';

export const COMPETITION_LONGLIST_VOTE_CRITERIA_ID = '8a8fcc2c48164488ba8451374252e2a6';

export const normalizeJuryVoteValue = (value: unknown): number => {
  if (value === 0 || value === 1) {
    return value;
  }
  if (value === '0' || value === '1') {
    return Number(value);
  }
  return -1;
};

export const getLonglistVoteValueFromCriteriaList = (
  criteriaList: { voteCriteriaId?: string; voteValue?: unknown }[] | undefined,
  voteCriteriaId: string = COMPETITION_LONGLIST_VOTE_CRITERIA_ID,
): number => {
  const current = criteriaList?.find((c) => c?.voteCriteriaId === voteCriteriaId);
  const normalized = normalizeJuryVoteValue(current?.voteValue);
  if (normalized === 0 || normalized === 1) {
    return normalized;
  }
  return -1;
};

export const isLonglistFormationCompetition = (
  competition?: CompetitionVotingModeSource & { status?: number },
): boolean =>
  !!competition
  && isTwoStageVotingCompetition(competition)
  && competition.status === STATUSES.LonglistFormation;

export const isCompetitionLonglistTabVisibleByStatus = (status?: number): boolean => {
  if (status == null) {
    return false;
  }
  if (status === STATUSES.LonglistFormation) {
    return false;
  }
  return status >= STATUSES.Voting;
};

type ProjectCompetitionGpa = {
  competitionId?: string;
  skipByVotes?: boolean;
};

export const isProjectInCompetitionLonglist = (
  project: { competitonsGPA?: ProjectCompetitionGpa[] } | undefined,
  competitionId: string,
): boolean => {
  const row = project?.competitonsGPA?.find((g) => g.competitionId === competitionId);
  return row?.skipByVotes === false;
};

export const shouldRestrictProjectsToCompetitionLonglist = (
  competition?: CompetitionVotingModeSource & { status?: number },
): boolean =>
  !!competition
  && isTwoStageVotingCompetition(competition)
  && competition.status === STATUSES.Voting;

export enum COMPETITION_TYPE {
  'WithoutQuestionnaire' = 0,
  'WithQuestionnaire' = 1,
  'WithNominations' = 3,
  'PreRegistration' = 4,
  'Automatic' = 5,
  'Rating' = 6,
  'RatingArt' = 7,
  'Special' = 8,
  'LmsExam' = 9,
  'RatingsFashion' = 10,
  'RatingsEducation' = 11,
  'RatingsStartups' = 12,
  'RatingsPlus' = 13,
  'Practices' = 14,
  //aki = 2
}

export const RATING_COMPETITION_TYPES: COMPETITION_TYPE[] = [
  COMPETITION_TYPE.Rating,
  COMPETITION_TYPE.RatingArt,
  COMPETITION_TYPE.RatingsFashion,
  COMPETITION_TYPE.RatingsEducation,
  COMPETITION_TYPE.RatingsStartups,
  COMPETITION_TYPE.RatingsPlus,
];

export const isRatingCompetitionType = (type?: number): boolean => {
  if (type === undefined || type === null) {
    return false;
  }

  return RATING_COMPETITION_TYPES.includes(type as COMPETITION_TYPE);
};

export const NEW_DAFES_CHOICE_COMPETITION_TYPES: COMPETITION_TYPE[] = [
  COMPETITION_TYPE.RatingsFashion,
  COMPETITION_TYPE.RatingsEducation,
  COMPETITION_TYPE.RatingsStartups,
  COMPETITION_TYPE.RatingsPlus,
];

export const isNewDafesChoiceCompetitionType = (type?: number): boolean => {
  if (type === undefined || type === null) {
    return false;
  }

  return NEW_DAFES_CHOICE_COMPETITION_TYPES.includes(type as COMPETITION_TYPE);
};

export const normalizedCompetitionStatuses = (): Record<string, number> =>
  Object.entries(STATUSES)
    .filter(([, value]) => typeof value === 'number')
    .reduce<Record<string, number>>((acc, [key, value]) => {
      acc[key.toLowerCase()] = value as number;
      return acc;
    }, {});

export const RATING_PROJECT_TYPE_TO_COMPETITION_TYPE: Record<number, COMPETITION_TYPE> = {
  0: COMPETITION_TYPE.Rating,
  1: COMPETITION_TYPE.RatingArt,
  2: COMPETITION_TYPE.RatingsFashion,
  3: COMPETITION_TYPE.RatingsEducation,
  4: COMPETITION_TYPE.RatingsStartups,
  5: COMPETITION_TYPE.RatingsPlus,
};
export const TEAM_FORM_CONTINUE_COMPETITION_QUERY = 'continueCompetition';
export const TEAM_FORM_DEFER_APPLY_PROJECT_QUERY = 'deferApplyProject';
export const QUERY_LEGAL_CONTEST_PROJECT_THEN_FORM = 'legalContestProjectThenForm';
export const QUERY_RESUME_LEGAL_CONTEST_AFTER_FORM = 'resumeLegalContestAfterForm';

export const PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID = '61557662888148bf807a481e0017c11b';

export const COMPETITION_TYPE_List: {
  label: string;
  value: number;
}[] = Object.entries(COMPETITION_TYPE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

/**
 * Доступ к подаче проекта (актуально для конкурса с пререгистрацией)
 */
export enum COMPETITION_APPLY_PROJECT_TYPE {
  'AllUsers' = 0,
  'ApprovedOnly' = 1,
}

/**
 * Время подачи проекта (актуально для конкурса с пререгистрацией)
 */
export enum COMPETITION_MOMENT_APPLY_PROJECT_TYPE {
  'AfterCompetitionRegistration' = 0,
  'AppointedTime' = 1,
}

export const COMPETITION_APPLY_PROJECT_TYPE_List: {
  label: string;
  value: number;
}[] = Object.entries(COMPETITION_APPLY_PROJECT_TYPE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

export const COMPETITION_MOMENT_APPLY_PROJECT_TYPE_List: {
  label: string;
  value: number;
}[] = Object.entries(COMPETITION_MOMENT_APPLY_PROJECT_TYPE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

export type WinnerT = { project: Project, position: number }

export type NominationWinners = {
  id: string;
  color?: string;
  name: string;
  projects: WinnerT[];
}
